import {Breakpoints, ThemeOptions} from '@mui/material';
import {CSSProperties} from 'react';

import {Tokens} from '../../../../types/generated/Tokens';

export const MuiFormControlLabel = (
  {focus, switchInput}: Tokens,
  mediaQueries: Breakpoints
): ThemeOptions['components'] => ({
  MuiFormControlLabel: {
    styleOverrides: {
      root: {
        padding: '12px 4px 12px 0', // TODO: UHC version is `12px 0`,
        margin: 0,
        '&:active, &:focus, &:focus-within': {
          outline: `${focus.outline.width} ${focus.outline.style} ${focus.outline.color}`
        },
        // For nested checkboxes, parent has indeterminate state
        '&.checkboxListHeader > .MuiFormControlLabel-label': {
          fontWeight: 'bold'
        },
        '&.checkboxListItem': {
          marginLeft: 16
        },

        // For Switch using formcontrol label
        '&.formControlLabelSwitch': {
          margin: 0,
          padding: '4px 0',
          '.MuiFormControlLabel-label': {
            color: switchInput.label.desktop.font.color,
            lineHeight: switchInput.label.desktop.font.lineHeight,
            fontSize: switchInput.label.desktop.font.size,
            fontWeight: switchInput.label.desktop.font.weight as CSSProperties['fontWeight'],
            [mediaQueries.down('sm')]: {
              lineHeight: switchInput.label.mobile.font.lineHeight,
              fontSize: switchInput.label.mobile.font.size,
              fontWeight: switchInput.label.mobile.font.weight as CSSProperties['fontWeight']
            }
          }
        },
        '&.MuiFormControlLabel-labelPlacementEnd label': {
          marginLeft: 8
        },
        // Radio Button Chip and Checkbox Chip
        '&.MuiFormControlLabelRadioChip-root, &.MuiFormControlLabelCheckboxChip-root': {
          marginBottom: '8px',
          padding: 0,
          position: 'relative',

          '&:focus-within, &:active': {
            outlineOffset: '3px'
          }
        }
      },
      label: {},
      labelPlacementTop: {},
      labelPlacementStart: {
        '&.formControlLabelSwitch': {
          display: 'flex',
          justifyContent: 'space-between',
          '.MuiFormControlLabel-label': {
            marginRight: 24
          }
        }
      },
      labelPlacementBottom: {}
    }
  }
});
